import React, { useEffect, useState } from "react";
import { Card, Grid, List, ListItem, ListItemText, Avatar, Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import CustomNavbar from "components/CustomNavbar";
import ProjectActions from "./ProjectActions"; // Import your existing ProjectActions component
import ProjectComments from "./ProjectComments";
import { RequestService, imageUrl } from "services/RequestService";

import ProjectsDetails from "./ProjectDetails";
import ProjectManagers from "./ProjectManagers";

import Cookies from "js-cookie";
let userTypeName = Cookies.get("userTypeName");



const ProjectManager="ProjectManager".toUpperCase();
const isProjectManager = userTypeName?.toUpperCase() === ProjectManager;
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().slice(0, 10).split("-").reverse().join("-");
};

const ProjectInfoPage = () => {
  const [initialValuesState, setInitialValuesState] = useState({
    id: 1,
    name: "مشروع تطوير البرمجيات",
    description: "تطوير نظام إدارة المشاريع الخاص بالشركة لتسهيل عملية التنسيق والتواصل بين الفرق.",
    clientName: "شركة العمران",
    budget: 500000,
    budgetName: "دينار",
    budgetStatus: "مستقر",
    actualExpenditure: 200000,
    startedDate: "2021-10-01",
    endedDate: "2022-03-31",
    categoryName: "تطوير البرمجيات",
    projectStatusName: "مستمر",
    progress: 50,
    changeRequestCount: 2,
    imageUrl: "https://via.placeholder.com/800x400",
    projectManagers: [],
  });

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");

  useEffect(() => {
    const fetchData = async () => {
      await RequestService.get(`Project/${id}`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data.data;
            data.startedDate = formatDate(data.startedDate);
            data.endedDate = formatDate(data.endedDate);
            setInitialValuesState(data);
          }
        })
        .catch((errorResponse) => {
          console.log(errorResponse);
        });
    };
    fetchData();
  }, [id]);

  return (
    <DashboardLayout>
      <CustomNavbar
        title={`تفاصيل ${initialValuesState.name}`}
        route={[
          { path: "pages/projects/viewprojects", display: "المشاريع" },
          { path: `pages/projects/projects/Info?id=${id}`, display: "تفاصيل المشروع" }
        ]}
      />
      <MDBox pt={6} pb={3} px={10} >
        <ProjectActions projectId={id} />
      </MDBox>
      <ProjectsDetails initialValuesState={initialValuesState} />
     
      <MDBox pt={3} px={10}>
        <ProjectManagers projectManager={initialValuesState.projectManagers} />
      </MDBox>
      <MDBox pt={3} px={10}>
        <ProjectComments projectId={id} />
      </MDBox>
      

      <Footer />
    </DashboardLayout>
  );
};

export default ProjectInfoPage;
